module.exports = __webpack_public_path__ + "img/pmsm2.ac401240.png";